import * as Yup from "yup";

export const businessInformationValidationSchema = Yup.object()
  .shape({
    businessLegalName: Yup.string().required("Business Legal Name is required"),
    businessDBA: Yup.string(),
    businessEIN: Yup.string()
      .matches(/^\d{2}-\d{7}$/, "EIN must be in the format XX-XXXXXXX")
      .when("businessStructure", {
        is: (value) => value !== "SOLE_PROPRIETORSHIP",
        then: (schema) => schema.required("Business EIN is required"),
        otherwise: (schema) => schema.notRequired(),
      }),
    businessStructure: Yup.string().required("Business Type is required"),
    businessIncorporationState: Yup.string().required(
      "State of incorporation is required",
    ),
    description: Yup.string()
      .matches(
        /^[a-zA-Z\d$ ',.\-_!@#$%^&*+=?"\n]+$/,
        "Description contains invalid characters",
      )
      .test(
        "minWords",
        "Description must contain at least 4 words",
        (value) => {
          if (!value) return true;
          const wordCount = value.trim().split(/\s+/).filter(Boolean).length;
          return wordCount >= 4;
        },
      ),
    websiteURL: Yup.string().matches(
      /^((((https?|ftps?|gopher|telnet|nntp):\/\/)|(mailto:|news:))(%[0-9A-Fa-f]{2}|[-()_.!~*';/?:@&=+$,A-Za-z0-9])+)([).!';/?:,][\s])?$/,
      "errorCompanyWebsite",
    ),
    phoneNumber: Yup.string().required("Phone number is required"),
    annualRevenue: Yup.number()
      .typeError("Annual revenue is required")
      .required("Annual revenue is required")
      .moreThan(0, "Annual revenue is required"),
  })
  .test(
    "websiteOrDescriptionRequired",
    "Either website URL or description is required",
    function (value) {
      const { websiteURL, description } = value || {};
      return Boolean(websiteURL || description);
    },
  );
